var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalRedeemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72230",
    "data-name": "Path 72230",
    d: "M14,2A8,8,0,0,1,17.3,17.3,8,8,0,1,1,6.711,6.71,8,8,0,0,1,14,2ZM10,8a6,6,0,1,0,6,6A6,6,0,0,0,10,8Zm1,1v1h2v2H9a.5.5,0,0,0-.09.992L9,13h2a2.5,2.5,0,0,1,0,5v1H9V18H7V16h4a.5.5,0,0,0,.09-.992L11,15H9a2.5,2.5,0,0,1,0-5V9Zm3-5A5.985,5.985,0,0,0,9.521,6.016C9.681,6.008,9.843,6,10,6a8,8,0,0,1,8,8q0,.244-.014.484A6,6,0,0,0,14,4Z",
    transform: "translate(-2.005 -2.003)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRedeemIcon);
export default __webpack_public_path__ + "static/media/total_redeem_icon.9205ac4eb09a975396c9462116e960f4.svg";
export { ForwardRef as ReactComponent };